import { render, staticRenderFns } from "./loyverse_webhook.vue?vue&type=template&id=4145d032&scoped=true&"
import script from "./loyverse_webhook.vue?vue&type=script&lang=js&"
export * from "./loyverse_webhook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4145d032",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4145d032')) {
      api.createRecord('4145d032', component.options)
    } else {
      api.reload('4145d032', component.options)
    }
    module.hot.accept("./loyverse_webhook.vue?vue&type=template&id=4145d032&scoped=true&", function () {
      api.rerender('4145d032', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/organizations/advanced/loyverse_webhook.vue"
export default component.exports